

























































































































































































































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseToggleSwitch from "@/app/shared/components/base/BaseToggleSwitch.vue";
import Dropzone from "@/app/modules/work/components/TheSideMenuDropzone.vue";
import { ResizeObserver } from "vue-resize";
import { Item } from "../models/classes/Item";
import { ItemVariation } from "../models/classes/ItemVariation";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { VPopover, VClosePopover } from "v-tooltip";
import draggable from "vuedraggable";
import { VTooltip } from "v-tooltip";

export default Vue.extend({
  name: "SideMenu",
  components: {
    BaseCheckbox,
    BaseInput,
    BaseButton,
    BaseToggleSwitch,
    Dropzone,
    ResizeObserver,
    vueCustomScrollbar,
    VPopover,
    draggable,
  },
  directives: {
    "close-popover": VClosePopover,
    tooltip: VTooltip,
  },
  data: function () {
    return {
      openedItemsIds: [],
      checkedCount: 0,
      isDragOver: false,
      itemsBlockHeight: 0,
      lastShiftObject: null,
      isExporting: false,
      isTempCollapsed: false,
    };
  },
  computed: {
    items: {
      get: function () {
        return this.$store.state.items;
      },
      set: function (items) {
        this.$store.commit("setItems", items);
      },
    },
    copiedVariationSettings: {
      get: function () {
        return this.$store.state.copiedVariationSettings;
      },
      set: function (copiedVariationSettings) {
        this.$store.commit("copiedVariationSettings", copiedVariationSettings);
      },
    },
    deletedObjects: function () {
      return this.$store.state.deletedObjects;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    isSaveOriginalName: function () {
      return this.$store.state.userInfo.isSaveOriginalName;
    },
    isSomeCheck: function () {
      return this.items.length === 0
        ? false
        : !this.items.every((i) => i.variations.every((v) => v.checked)) &&
            this.items.some((i) => i.variations.some((v) => v.checked));
    },
    isAnyCheckedAndExpanded: function () {
      return (
        this.openedItemsIds.length !== 0 &&
        (this.isSomeCheck || this.isAllChecked) &&
        this.items
          .filter((it) => it.checked)
          .some((it) => this.openedItemsIds.includes(it.fileId))
      );
    },
    variationNamingTemplate: function () {
      return this.$store.state.variationNamingTemplate;
    },
    isAllChecked: {
      // getter
      get: function () {
        return this.items.length === 0
          ? false
          : this.items.every((i) => i.variations.every((v) => v.checked));
      },
      // setter
      set: function (newValue) {
        if (newValue) {
          this.items.forEach((item) => {
            item.checked = true;
            item.variations.forEach((variation) => {
              variation.checked = true;
            });
          });
        } else {
          this.items.forEach((item) => {
            item.checked = false;
            item.variations.forEach((variation) => {
              variation.checked = false;
            });
          });
        }
      },
    },
    filesToUpload: function () {
      return this.$store.state.filesToUpload;
    },
    tasksFromUAToUpload: function () {
      return this.$store.state.tasksFromUAToUpload;
    },
    keymap: function () {
      return {
        "command+a": (event) => {
          if (!event.metaKey) {
            return;
          }
          event.preventDefault();
          this.isAllChecked = true;
        },
        "ctrl+a": (event) => {
          event.preventDefault();
          this.isAllChecked = true;
        },
        "ctrl+shift+a": (event) => {
          event.preventDefault();
          this.isAllChecked = false;
        },
        "command+shift+a": (event) => {
          if (!event.metaKey) {
            return;
          }
          event.preventDefault();
          this.isAllChecked = false;
        },
        delete: this.onMultiDelete,
        //backspace: this.onMultiDelete,
        "ctrl+d": (event) => {
          event.preventDefault();
          this.onMultiDuplicate();
        },
        "command+d": (event) => {
          if (!event.metaKey) {
            return;
          }
          event.preventDefault();
          this.onMultiDuplicate();
        },
        /*         tab: () => {
          this.isAllChecked = true;
        }, */
      };
    },
  },
  created() {
    $eventsBus.$on("openSideMenuItem", (item) => {
      this.onClickArrow(item);
    });
    $eventsBus.$on("itemsExported", () => {
      this.isExporting = false;
    });
    window.addEventListener("keyup", this.doKeyupListeners);
  },
  destroyed() {
    window.removeEventListener("keyup", this.doKeyupListeners);
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.checkedCount = 0;
        this.items.forEach((item) => {
          this.checkedCount += item.variations.filter((v) => v.checked).length;
        });
      },
    },
  },
  methods: {
    onDragItem(e) {
      this.selectItem(this.items[e.oldDraggableIndex]);
    },
    onDropItem(e) {
      this.expandTemporarilyCollapsedItem(this.items[e.newDraggableIndex]);
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    doKeyupListeners(e) {
      if (e.key === "Shift") {
        this.lastShiftObject = null;
      }
    },
    onResize() {
      this.itemsBlockHeight = this.$refs.items
        ? this.$refs.items.$el.getBoundingClientRect().height
        : 0;
    },
    onMultiDuplicate() {
      if (this.checkedCount !== 0) {
        this.items.forEach((i) => {
          i.variations
            .map((it) => it)
            .filter((v) => v.checked)
            .forEach((v) => {
              i.variations.push(v.copy());
              if (!this.openedItemsIds.includes(i.fileId)) {
                this.openedItemsIds.push(i.fileId);
              }
            });
        });
        $eventsBus.$emit("saveUserWorkspace", true);

        //TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.reachGoal("selected_files_duplicate");
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    onDeleteItem(item) {
      this.$store.commit("deleteItem", item);
      //this.deletedObjects.push([item]);
      this.$store.commit("addNewStateToHistory");
      $eventsBus.$emit("saveUserWorkspace", true);

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("videoplayback_delete");
        }
      } catch (e) {
        console.error(e);
      }
    },
    onResetItem(item) {
      item.variations = [];

      if (item.isForSlice) {
        Item.videoSizes.forEach((size) =>
          item.addNewVariation(
            this.isSaveOriginalName,
            JSON.parse(JSON.stringify(this.variationNamingTemplate)),
            size.name
          )
        );
      } else {
        this.createNewOutput(item);
      }
      $eventsBus.$emit("saveUserWorkspace", true);
      this.$store.commit("addNewStateToHistory");

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("reset_item");
        }
      } catch (e) {
        console.error(e);
      }
    },
    onSwitchSlicerMode(item) {
      if (item.inputSize.name !== "S") {
        return;
      }
      if (item.isForSlice) {
        $eventsBus.$emit("openConfirmWindow", {
          isInline: true,
          message: "Disable slicer mode for all videos or for this video?",
          acceptTitle: "This video",
          discardTitle: "All videos",
          acceptCallback: () => {
            item.switchSlicerMode(false);
          },
          discardCallback: (() => {
            this.items.forEach((item) => {
              item.switchSlicerMode(false);
            });
          }).bind(this),
          needCloseClickOutside: false,
        });
      } else {
        $eventsBus.$emit("openConfirmWindow", {
          isInline: true,
          message: "This will reset video to default settings",
          acceptTitle: "Cancel",
          discardTitle: "Apply",
          acceptCallback: () => {
            return
          },
          discardCallback: (() => {
            item.switchSlicerMode(true)
            this.onResetItem(item)
          }).bind(this),
          needCloseClickOutside: false,
        })
      }
    },
    onMultiDelete() {
      if (this.checkedCount !== 0) {
        let objectsToDelete = [];
        this.items
          .map((it) => it)
          .forEach((i) => {
            if (i.checked) {
              this.$store.commit("deleteItem", i);
              objectsToDelete.push(i);
            } else {
              i.variations
                .filter((v) => v.checked)
                .forEach((v) => {
                  this.onDeleteVariation(i, v, false);
                  objectsToDelete.push(v);
                  if (i.currentVariation === v) {
                    i.currentVariation = i.variations[0];
                  }
                });
              this.onCheckItemVariation(i);
            }
          });
        if (objectsToDelete.length !== 0) {
          //this.deletedObjects.push(objectsToDelete);
          this.$store.commit("addNewStateToHistory");
        }
        $eventsBus.$emit("saveUserWorkspace", true);

        //TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.reachGoal("selected_files_delete");
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    onCopySettings(variation: ItemVariation) {
      this.copiedVariationSettings = variation.copyParameters();
    },
    onPasteSettings(variation: ItemVariation, variationParentItem: Item) {
      if (!!this.copiedVariationSettings) {
        if (!variation.checked) {
          variation.pasteParameters(
            this.copiedVariationSettings,
            variationParentItem
          );
        } else {
          this.items.forEach((item) => {
            item.variations
              .filter((v) => v.checked)
              .forEach((v) => {
                v.pasteParameters(this.copiedVariationSettings, item);
              });
          });
        }

        variation.getAllOverlays().forEach((overlay) => {
          $eventsBus.$emit(
            "updateAllDurationForAnimation",
            overlay,
            variation.speed
          );

          $eventsBus.$emit("updateAnimation", overlay.id);
        });
      }
    },
    onDeleteVariation(item, variation, addToDeleted = true) {
      if (item.variations.length === 1) {
        if (addToDeleted) {
          //this.deletedObjects.push([item]);
          this.$store.commit("addNewStateToHistory");
        }
        this.$store.commit("deleteItem", item);
      } else {
        item.variations.splice(item.variations.indexOf(variation), 1);
        if (addToDeleted) {
          //this.deletedObjects.push([variation]);
          this.$store.commit("addNewStateToHistory");
        }
        //TODO понять почему иначе смена не происходит
        setTimeout(() => {
          this.onClickSubitem(item, item.variations[0]);
          this.onCheckItemVariation(item);
        }, 50);
      }
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    collapseItem(item) {
      this.openedItemsIds.splice(this.openedItemsIds.indexOf(item.fileId), 1);
    },
    collapseItemTemporarily(item) {
      const scrollHeight = this.$refs.items.$el.scrollHeight;
      this.$refs.resizeObserver.$el.style.minHeight = `${scrollHeight}px`;
      if (this.openedItemsIds.includes(item.fileId)) {
        this.openedItemsIds.splice(this.openedItemsIds.indexOf(item.fileId), 1);
        this.isTempCollapsed = true;
      }
    },
    expandItem(item) {
      this.openedItemsIds.push(item.fileId);
    },
    expandTemporarilyCollapsedItem(item) {
      this.$refs.resizeObserver.$el.style.minHeight = "auto";
      if (this.isTempCollapsed) {
        this.expandItem(item);
        this.isTempCollapsed = false;
      }
    },
    onClickArrow(item, forcePush = false) {
      if (!this.openedItemsIds.includes(item.fileId)) {
        this.expandItem(item);
      } else {
        if (forcePush) {
          return;
        }
        this.collapseItem(item);
      }
      if (!this.isSelectedItem(item)) {
        this.selectItem(item);
        $eventsBus.$emit("scrollToTopToolsPanel");
      }
    },
    onClickCommonArrow() {
      if (this.isAnyCheckedAndExpanded)
        this.items
          .filter((it) => it.checked)
          .forEach((it) => {
            if (this.openedItemsIds.includes(it.fileId)) {
              this.collapseItem(it);
            }
          });
    },
    onCntrlClickItem(item) {
      item.checked = !item.checked;
      this.onCheckItem(item);
    },
    onShiftClickItem(item) {
      if (this.lastShiftObject && this.lastShiftObject !== item) {
        let thisIndex = this.items.indexOf(item);
        let checkValue = !item.checked;

        if (this.lastShiftObject instanceof Item) {
          let lastIndex = this.items.indexOf(this.lastShiftObject);
          for (
            let i = Math.min(thisIndex, lastIndex);
            i < Math.max(thisIndex, lastIndex) + 1;
            i++
          ) {
            const currentItem = this.items[i];
            currentItem.checked = checkValue;
            this.onCheckItem(currentItem);
          }
        } else if (this.lastShiftObject instanceof ItemVariation) {
          let lastShiftObjectParentItem = this.items.find(
            (item) => item.id === this.lastShiftObject.parentItem.id
          );
          let lastIndex = this.items.indexOf(lastShiftObjectParentItem);
          for (
            let i = Math.min(thisIndex, lastIndex);
            i < Math.max(thisIndex, lastIndex) + 1;
            i++
          ) {
            const currentItem = this.items[i];
            if (currentItem.id !== this.lastShiftObject.parentItem.id) {
              currentItem.checked = checkValue;
              this.onCheckItem(currentItem);
            } else {
              let lastVariationIndex = currentItem.variations.indexOf(
                this.lastShiftObject
              );
              currentItem.variations.forEach((variation, variationIndex) => {
                if (thisIndex <= lastIndex) {
                  if (variationIndex <= lastVariationIndex) {
                    variation.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                } else {
                  if (variationIndex >= lastVariationIndex) {
                    variation.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                }
              });
            }
          }
        }
        this.lastShiftObject = item;
      } else {
        this.lastShiftObject = item;
        this.onCntrlClickItem(item);
      }
    },
    selectItem(item) {
      this.$store.commit("changeSelectItem", item);
    },
    isSelectedItem(item) {
      return this.previewItem === item;
    },
    isHasSomeChecked(item) {
      return (
        !item.variations.every((v) => v.checked) &&
        item.variations.some((v) => v.checked)
      );
    },
    onCheckItem(item) {
      item.variations.forEach((v) => {
        v.checked = item.checked;
      });
      this.$forceUpdate();
    },
    onCheckItemVariation(item) {
      if (item.variations.every((v) => v.checked)) {
        item.checked = true;
      } else {
        item.checked = false;
      }
      this.$forceUpdate();
    },
    onClickNewOutput(item) {
      this.createNewOutput(item);

      $eventsBus.$emit("saveUserWorkspace", true);
      this.$store.commit("addNewStateToHistory");

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("add_new_output");
        }
      } catch (e) {
        console.error(e);
      }
    },
    createNewOutput(item) {
      item.checked = false;
      item.addNewVariation(
        this.isSaveOriginalName,
        JSON.parse(JSON.stringify(this.variationNamingTemplate))
      );
    },
    onClickSubitem(item, variation) {
      if (item.currentVariation !== variation || !this.isSelectedItem(item)) {
        this.selectItem(item);
        item.currentVariation = variation;

        $eventsBus.$emit("scrollToTopToolsPanel");
      }
    },
    onCntrlClickSubitem(item, variation) {
      variation.checked = !variation.checked;
      this.onCheckItemVariation(item);
    },
    onShiftClickSubitem(item, variation) {
      if (this.lastShiftObject && this.lastShiftObject !== variation) {
        let thisIndex = this.items.indexOf(item);
        let checkValue = !variation.checked;

        if (this.lastShiftObject instanceof Item) {
          let lastIndex = this.items.indexOf(this.lastShiftObject);
          for (
            let i = Math.min(thisIndex, lastIndex);
            i < Math.max(thisIndex, lastIndex) + 1;
            i++
          ) {
            const currentItem = this.items[i];
            if (currentItem.id !== variation.parentItem.id) {
              currentItem.checked = checkValue;
              this.onCheckItem(currentItem);
            } else {
              let variationIndex = currentItem.variations.indexOf(variation);
              currentItem.variations.forEach((v, vI) => {
                if (thisIndex > lastIndex) {
                  if (vI <= variationIndex) {
                    v.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                } else {
                  if (vI >= variationIndex) {
                    v.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                }
              });
            }
          }
        } else if (this.lastShiftObject instanceof ItemVariation) {
          let lastShiftObjectParentItem = this.items.find(
            (item) => item.id === this.lastShiftObject.parentItem.id
          );
          let lastIndex = this.items.indexOf(lastShiftObjectParentItem);
          for (
            let i = Math.min(thisIndex, lastIndex);
            i < Math.max(thisIndex, lastIndex) + 1;
            i++
          ) {
            const currentItem = this.items[i];
            if (thisIndex !== lastIndex && i !== thisIndex && i !== lastIndex) {
              currentItem.checked = checkValue;
              this.onCheckItem(currentItem);
            } else if (lastIndex === thisIndex) {
              let thisVariationIndex =
                currentItem.variations.indexOf(variation);
              let lastVariationIndex = currentItem.variations.indexOf(
                this.lastShiftObject
              );
              currentItem.variations.forEach((variation, variationIndex) => {
                if (
                  variationIndex >=
                    Math.min(thisVariationIndex, lastVariationIndex) &&
                  variationIndex <=
                    Math.max(thisVariationIndex, lastVariationIndex)
                ) {
                  variation.checked = checkValue;
                  this.onCheckItemVariation(currentItem);
                }
              });
            } else if (i === thisIndex) {
              let thisVariationIndex =
                currentItem.variations.indexOf(variation);
              currentItem.variations.forEach((variation, variationIndex) => {
                if (thisIndex >= lastIndex) {
                  if (variationIndex <= thisVariationIndex) {
                    variation.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                } else {
                  if (variationIndex >= thisVariationIndex) {
                    variation.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                }
              });
            } else if (i === lastIndex) {
              let lastVariationIndex = currentItem.variations.indexOf(
                this.lastShiftObject
              );
              currentItem.variations.forEach((variation, variationIndex) => {
                if (thisIndex >= lastIndex) {
                  if (variationIndex >= lastVariationIndex) {
                    variation.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                } else {
                  if (variationIndex <= lastVariationIndex) {
                    variation.checked = checkValue;
                    this.onCheckItemVariation(currentItem);
                  }
                }
              });
            }
          }
        }
        this.lastShiftObject = variation;
      } else {
        this.lastShiftObject = variation;
        this.onCntrlClickSubitem(item, variation);
      }
    },
    isCheckedItemsNotLoaded() {
      return this.items.some(
        (i) =>
          !i.loadingParameters.loaded && i.variations.some((v) => v.checked)
      );
    },
    canExport() {
      return (
        this.items.length &&
        (this.isSomeCheck || this.isAllChecked) &&
        !this.isExporting &&
        !this.isCheckedItemsNotLoaded()
      );
    },
    onClickExport() {
      if (!this.canExport()) {
        return;
      }
      let countToExport = this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked).length;
      if (countToExport === 0) {
        return;
      }
      this.isExporting = true;
      //this.$store.commit("showDownloadPanel", true);
      $eventsBus.$emit("exportItems");

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("export", {
            "Клик на export": countToExport,
          });
        }
      } catch (e) {
        console.error(e);
      }
      //$eventsBus.$emit("saveUserWorkspace");
    },
  },
});
